import React from "react";
import InspectionListTable from "./table/InspectionListTable";
import { useMediaQuery } from "react-responsive";

function InspectionList() {
  const isMobile = useMediaQuery({ query: "(max-width: 420px)" });

  return (
    <div className="mt-">
      <div
        className={`${isMobile ? "" : "valign-wrapper space-between"}`}
        style={{ marginBottom: "7px" }}
      >
        <h4>Inspection Response List</h4>
      </div>
      <InspectionListTable />
    </div>
  );
}

export default InspectionList;
